export default function dimensionsOverlap({
  leftOne,
  rightOne,
  leftTwo,
  rightTwo,
}) {
  const overlap = rightOne > leftTwo && rightTwo > leftOne;

  return overlap;
}



// WEBPACK FOOTER //
// /Users/jamess/webdev/react-projects/materialish/docs/src/vendor/react-over/compute-position/dimensions-overlap.js